import mixpanel from 'mixpanel-browser'

const getMixpanelKey = () => {
  const currentDomain = window.location.hostname;
  let mixPanelKey = 'e6b0e7619b91ab6cffa252f87cd90962';
  switch(currentDomain){
    case 'squadlytics.dev':
      mixPanelKey = 'f914411c83715b8c4695679a0a860982';
      break;
    case 'squadlytics-staging.com':
      mixPanelKey = '488d32f0ca6b98abfc552654a460a952';
      break;
    case 'squadlytics.com':
      mixPanelKey = 'e1d546305637f1d8811709e9dfc23c83';
      break;
    default:
      mixPanelKey = 'f914411c83715b8c4695679a0a860982';
  } 
  return mixPanelKey;
}

export const mixpanelTrack = (event, config = {}) => {
  mixpanel.init(getMixpanelKey())
  mixpanel.track(event, config)
}


// WEBPACK FOOTER //
// ./src/utils/mixpanel.js